module.exports = __webpack_public_path__ + "img/2.58064388.png";